import {
  DashboardDataTableColumnKind,
  buildDashboardDataTableColumns,
} from '@shigo-ui/dashboard-ui';

import { formatCurrency } from '../../../../../lib/format';
import { dashboardT } from '../../../../../lib/messages';
import {
  PlacementDeliveryType,
  PlacementPricingType,
  type Placement,
} from '../../../../supply/placements/model';

export function buildIntegrationPlacementsDialogColumns() {
  return buildDashboardDataTableColumns<Placement>([
    {
      id: 'name',
      kind: DashboardDataTableColumnKind.Text,
      header: dashboardT('placements.name'),
      headerClassName: 'w-[42%] pl-4',
      className: 'w-[42%] pl-4 font-medium',
      sortable: true,
      value: (placement) => placement.name,
    },
    {
      id: 'deliveryType',
      kind: DashboardDataTableColumnKind.Text,
      header: dashboardT('placements.deliveryType'),
      headerClassName: 'w-[22%]',
      className: 'w-[22%]',
      sortable: true,
      value: (placement) => resolveDeliveryTypeLabel(placement.deliveryType),
    },
    {
      id: 'bidFloor',
      kind: DashboardDataTableColumnKind.Text,
      header: dashboardT('placements.floor'),
      headerClassName: 'w-[18%]',
      className: 'w-[18%]',
      sortable: true,
      value: (placement) => formatCurrency(placement.bidFloor),
    },
    {
      id: 'pricing',
      kind: DashboardDataTableColumnKind.Text,
      header: dashboardT('placements.cpm'),
      headerClassName: 'w-[18%] pr-4',
      className: 'w-[18%] pr-4',
      sortable: true,
      value: (placement) =>
        placement.pricingType === PlacementPricingType.Cpm
          ? formatCurrency(placement.pricing)
          : '-',
    },
  ]);
}

function resolveDeliveryTypeLabel(deliveryType: PlacementDeliveryType | null | undefined) {
  switch (deliveryType) {
    case PlacementDeliveryType.App:
      return dashboardT('placements.delivery.app');
    case PlacementDeliveryType.Ctv:
      return dashboardT('placements.delivery.ctv');
    case PlacementDeliveryType.Web:
      return dashboardT('placements.delivery.web');
    default:
      return '-';
  }
}
